import React, { Component } from "react"
import BaseModal, { ModalActions, SaveButton, CancelButton } from "../../../containers/UI/Modal/BaseModal";
import SelectRow from "../../configuration/Rows/SelectRow/SelectRow"
import classes from "./FilterModal.css"


class FilterModal extends Component {

  state = {
    customer: "all-customers",
    gateway: "all-gateways",
  }
  allCustomers = { label: "All customers", value: "all-customers" }
  allGateways = { label: "All gateways", value: "all-gateways" }

  componentDidMount() {
    if (this.props.filteredCustomer && this.props.filteredCustomer !== "") {
      this.setState({ customer: this.props.filteredCustomer })
    }
    if (this.props.filteredGateway && this.props.filteredGateway !== "") {
      this.setState({ gateway: this.props.filteredGateway })
    }
  }

  // Get gateway options filtered by selected customer
  getFilteredGatewayOptions = () => {
    if (!this.props.gatewayOptions) return []

    if (this.state.customer === "all-customers") {
      return this.props.gatewayOptions
    }

    // Filter gateways to only show those belonging to the selected customer
    return this.props.gatewayOptions.filter(gateway => gateway.customerId === this.state.customer)
  }

  // Handle customer change - reset gateway if it no longer belongs to selected customer
  handleCustomerChange = (newValue) => {
    const newCustomerId = newValue.value
    this.setState({ customer: newCustomerId })

    // If a gateway was selected and the customer changed, check if gateway still valid
    if (this.state.gateway !== "all-gateways" && newCustomerId !== "all-customers") {
      const gatewayStillValid = this.props.gatewayOptions?.some(
        gw => gw.value === this.state.gateway && gw.customerId === newCustomerId
      )
      if (!gatewayStillValid) {
        this.setState({ gateway: "all-gateways" })
      }
    }
  }


  render() {
    const filteredGatewayOptions = this.getFilteredGatewayOptions()
    const showGatewayFilter = this.props.gatewayOptions && this.props.gatewayOptions.length > 0

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title="Filter licenses"
      >
        <div className={classes.filterRows}>
          <SelectRow
            title="Show licenses for"
            firstRow
            ultrawide
            defaultValue={"all-customers"}
            value={this.state.customer}
            onChange={this.handleCustomerChange}
            options={[this.allCustomers, ...this.props.customerOptions]}/>

          {showGatewayFilter && (
            <SelectRow
              title="Gateway"
              firstRow
              ultrawide
              defaultValue={"all-gateways"}
              value={this.state.gateway}
              onChange={(newValue) => this.setState({ gateway: newValue.value })}
              options={[this.allGateways, ...filteredGatewayOptions]}/>
          )}
        </div>

        <ModalActions>
          <CancelButton onClick={this.props.closeModal}/>
          <SaveButton onClick={() => { this.props.applyFilter(this.state.customer, this.state.gateway); this.props.closeModal() }}>
            Apply
          </SaveButton>
        </ModalActions>
      </BaseModal>
    )
  }
}


export default FilterModal;
